import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import WeeklyPicks from './WeeklyPicks'

const PicksOfTheWeek = () => {
    return (
        <Switch>
          <Route path={'/dashboard/promotion/add'} component={WeeklyPicks} />
        </Switch>
      );
};

export default PicksOfTheWeek;